export const mutation_add_prestazione_pagamento = `
mutation addPrestazionePagamento($prestazioneId: Int!, $valutaId: Int!, $valutaData: timestamp!, $valutaCambio: float8!, $valutaImporto: numeric!, $modalitaPagamentoId: Int!, $origineId: Int!, $importoEuro: numeric!, $data: timestamp!, $isoCode: String!) {
    insert_prestazione_pagamento_one(object: {PrestazioneId: $prestazioneId, ValutaId: $valutaId, ValutaData: $valutaData, ValutaCambio: $valutaCambio, ValutaImporto: $valutaImporto, ModalitaPagamentoId: $modalitaPagamentoId, OrigineId: $origineId, ImportoEuro: $importoEuro, Data: $data, IsoCode: $isoCode}) {
        Id
        PrestazioneId
        ValutaId
        ValutaData
        ValutaCambio
        ValutaImporto
        ImportoEuro
        ModalitaPagamentoId
        OrigineId
        CreatedOn
        ModifiedOn
        Data
        CreatedBy
        ModifiedBy
        IsoCode
        base_valutum {
            IsoCode
        }
        base_mezzo_pagamento {
            Value
        }
        base_origine_fondi {
            Value
        }
    }
}`;
export const mutation_update_prestazione_pagamento = `
mutation updatePrestazionePagamento($id: Int!, $valutaId: Int!, $valutaData: timestamp!, $valutaCambio: float8!, $valutaImporto: numeric!, $modalitaPagamentoId: Int!, $origineId: Int!, $importoEuro: numeric!, $data: timestamp!, $isoCode: String!) {
    update_prestazione_pagamento(where: {Id: {_eq: $id}}, _set: {ValutaId: $valutaId, ValutaData: $valutaData, ValutaCambio: $valutaCambio, ValutaImporto: $valutaImporto, ModalitaPagamentoId: $modalitaPagamentoId, OrigineId: $origineId, ImportoEuro: $importoEuro, Data: $data, IsoCode: $isoCode, ModifiedOn: "now()"}) {
        returning {
            Id
            PrestazioneId
            ValutaId
            ValutaData
            ValutaCambio
            ValutaImporto
            ImportoEuro
            ModalitaPagamentoId
            OrigineId
            CreatedOn
            ModifiedOn
            Data
            CreatedBy
            ModifiedBy
            IsoCode
            base_valutum {
                IsoCode
            }
            base_mezzo_pagamento {
                Value
            }
            base_origine_fondi {
                Value
            }        
        }
    }
}`;
export const mutation_delete_prestazione_pagamento = `
mutation deletePrestazionePagamento($id: Int!) {
    delete_prestazione_pagamento(where: {Id: {_eq: $id}}) {
        affected_rows
    }
}`;